import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetTrafficPctAddOptionsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetTrafficPctAddOptions`,
});

export const GetUtilizationDatesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetUtilizationDates`,
});

export const GetFailuresFiltersRequest = (role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetFailuresFilters`,
	params: { role }
});

export const GetFailuresPointsVoiceRequest = (userId, role, type, city, dates, failureType, cfn1Level) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetFailuresPoints`,
	data: { userId, role, type, city, dates, failureType, cfn1Level }
});

export const GetFailuresPointsPacketRequest = (userId, role, type, city, dates, failureType, cfn1Level) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetFailuresPoints`,
	data: { userId, role, type, city, dates, failureType, cfn1Level }
});

export const GetDriveTestsCitiesRequest = (userId, userOperator) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetDriveTestsCities`,
	params: { userId, userOperator }
});

export const GetDriveTestsDrivesRequest = (city) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetDriveTestsDrives`,
	params: { city }
});

export const GetDriveTestsDatesRequest = (city, drive) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetDriveTestsDates`,
	params: { city, drive }
});

export const GetDriveTestRequest = (userId, tech, city, dates, kpi) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetDriveTest`,
	data: { userId, tech, city, dates, kpi }
});

export const GetTopologyRequest = (userId, tech, bands, coordinates, selectedUtilizationDate, selectedTrafficPctAdd) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetTopology`,
	data: { userId, tech, bands, coordinates, selectedUtilizationDate, selectedTrafficPctAdd }
});

export const GetScannerRouteRequest = (userId, city, dates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/GetScannerRoute`,
	data: { userId, city, dates }
});

export const GetSitesIdsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetSitesIds`,
});

export const GetSiteIdLocationRequest = (siteId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetSiteIdLocation`,
	params: { siteId }
});

export const GetCarriersColorsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DualMap/GetCarriersColors`,
});

export const SaveCarrierColorRequest = (userId, tableId, colorCode) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DualMap/SaveCarrierColor`,
	data: { userId, tableId, colorCode }
});
